import React, { useState } from "react";
import SimpleSectionHeader from "./SimpleSectionHeader";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    question: "How to Process?",
    answer: "Just by signing up, you can easily start accessing our books and enjoy reading from day one.",
  },
  {
    question: "These are E-Books library?",
    answer: "No, we deliver physical copies of books to your doorstep for a real reading experience.",
  },
  {
    question: "What are the plans for memberships?",
    answer: "We offer flexible plans: 1 month, 3 months, 6 months, and 1 year. Choose what suits you best.",
  },
  {
    question: "How do I make the payment?",
    answer: "Payments can be made securely online through Razorpay using cards, UPI, or net banking.",
  },
  {
    question: "How many books can I read in one plan?",
    answer: "You can borrow one book at a time per your plan. Return it to request a new one.",
  },
  {
    question: "What about Delivery and Return Policy?",
    answer: "All deliveries and returns are completely free of charge for all members.",
  },
  {
    question: "If I register but do not borrow a book, can I use it later?",
    answer: "No, once registered, you must select a plan and activate your membership.",
  },
  {
    question: "What if I lose or damage the book?",
    answer: "You’ll be charged the cost of the book if lost or damaged beyond repair.",
  },
];

const FAQPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-primary-shade1 via-white to-primary-shade1 font-nunito">
      <div className="w-full bg-primary-navbarColor shadow">
        <SimpleSectionHeader title="FAQ's" />
      </div>

      <div className="py-12 px-4 sm:px-10">
        <div className="max-w-4xl mx-auto bg-white/70 backdrop-blur-glass rounded-3xl shadow-glass p-6 sm:p-10 animate-fade-in">
          <h2 className="text-3xl sm:text-4xl font-bold text-center text-primary font-nunito mb-10">
            Frequently Asked Questions
          </h2>

          {faqs.map((faq, index) => (
            <div
              key={index}
              className="mb-5 rounded-2xl border border-primary-shade2 overflow-hidden transition-all duration-300 shadow hover:shadow-3d"
            >
              <button
                className="w-full flex justify-between items-center px-6 py-4 text-left text-lg font-semibold text-primary-shade4 bg-primary-shade1 hover:bg-primary-shade1 focus:outline-none transition-colors"
                onClick={() => toggleIndex(index)}
              >
                <span>{faq.question}</span>
                <ChevronDown
                  className={`transition-transform duration-300 ${
                    activeIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>

              <div
                className={`px-6 pt-0 text-text-muted bg-white overflow-hidden transition-all duration-300 ease-in-out ${
                  activeIndex === index ? "max-h-96 py-4 border-t border-primary-shade1" : "max-h-0"
                }`}
              >
                <p className="text-base">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
